
        import * as module0 from '../images/howtoruby-logo.svg'
        const modules = {
            "../images/howtoruby-logo.svg": module0,
        };
        export default modules;
      